import { render, staticRenderFns } from "./TeamAdd.vue?vue&type=template&id=5c61f3cb&"
import script from "./TeamAdd.vue?vue&type=script&lang=js&"
export * from "./TeamAdd.vue?vue&type=script&lang=js&"
import style0 from "./TeamAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports